module.exports = __webpack_public_path__ + "static/approach-3-d7fa3f8c5a05fd0bed2cb66c3160cc3b.jpg";